import React from 'react';
import { connect } from 'react-redux';

import Error from '@/pages/_error';
import Container from '@/src/shared/components/Container';
import Section from '@/src/shared/components/Section';
import { ADVOCACY_ACCESS, checkAccess } from '@/src/shared/constants';

const PolicyOverview = props => {
  const { isLoggedIn, isLoading, role, PersonID = {} } = props;

  const hasAccess = checkAccess(ADVOCACY_ACCESS.POLICY_COMMITTEES, role);
  const isAuthorized = PersonID && Array.isArray(role) && hasAccess;
  const errorCode = isLoggedIn && !hasAccess ? 401.4 : 401;

  if (isLoading) return null;
  if (!isLoggedIn || !isAuthorized) return <Error status={errorCode} />;

  return (
    <>
      <Section>
        <Container>
          <h1>PolicyOverview</h1>
        </Container>
      </Section>
    </>
  );
};

const mapStateToProps = state => {
  const {
    auth: {
      isLoggedIn,
      isLoading,
      role,
      userinfo: { PersonID },
    },
  } = state;
  return {
    isLoggedIn,
    isLoading,
    role,
    PersonID,
  };
};

export default connect(mapStateToProps)(PolicyOverview);
